// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--3JLfU";
export var CloseButton = "styles-module--CloseButton--3wu5L";
export var Submit = "styles-module--Submit--mtJTk";
export var Submit_Icon = "styles-module--Submit_Icon--CqFBH";
export var Form_Content = "styles-module--Form_Content--Iqu5H";
export var Form_Content_Left = "styles-module--Form_Content_Left--1QhVx";
export var Form_Content_Right = "styles-module--Form_Content_Right--3mOoG";